<template>
  <div>
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick" v-if="level !== 'STORE'">
      <el-tab-pane label="全部" name="0"></el-tab-pane>
      <el-tab-pane label="设备收益" name="1"></el-tab-pane>
      <el-tab-pane label="贡献收益" name="2" v-if="level === 'AREA'"></el-tab-pane>
      <el-tab-pane label="提现支出" name="3"></el-tab-pane>
    </el-tabs> -->
    <com-search :columns="searchColumns" @search="handleSearch"></com-search>
    <h4 class="mb-10px">数据统计</h4>
    <div class="mb-15px flex justify-end">
      <el-button type="primary" @click="handleExport" :disabled="isExporting" :loading="isExporting">导出</el-button>
    </div>
    <div class="statistics">
      <div class="statistics-item">
        <div>总收入（元）:</div>
        <div class="statistics-item-value">{{ statisticsData.accountSum }}</div>
      </div>
      <div class="statistics-item">
        <div>钱包余额（元）:</div>
        <div class="statistics-item-value">{{ statisticsData.accountRest }}</div>
      </div>
      <div class="statistics-item">
        <div>累计充值收入（元）:</div>
        <div class="statistics-item-value">{{ statisticsData.calReChargeIncome }}</div>
      </div>
      <div class="statistics-item">
        <div>累计充电收入（元）:</div>
        <div class="statistics-item-value">{{ statisticsData.calChargeIncome }}</div>
      </div>
      <div class="statistics-item">
        <div>月卡收入（元）:</div>
        <div class="statistics-item-value">{{ statisticsData.calMonthCardIncome }}</div>
      </div>
      <div class="statistics-item">
        <div>累计提现金额（元）:</div>
        <div class="statistics-item-value">{{ statisticsData.calWithdrawAccount }}</div>
      </div>
      <div class="statistics-item">
        <div>提现中金额（元）:</div>
        <div class="statistics-item-value">{{ statisticsData.withdrawingAccount }}</div>
      </div>
      <div class="statistics-item">
        <div>累计退单金额（元）:</div>
        <div class="statistics-item-value">{{ statisticsData.calRefundAccount }}</div>
      </div>
    </div>
    <h4 class="mb-10px">钱包明细</h4>
    <com-table ref="table" :columns="columns" :defaultParams="defaultParams" :api="api">
      <template #status="row">
        {{ typeStatus[row.data.type] }}
      </template>
      <template #createdTime="row">
        {{ row.data.createTime | formatDate }}
      </template>
      <template #sum="row"> {{ row.data.inout === '1' ? '+' : '-' }}{{ row.data.sum }} </template>
    </com-table>
  </div>
</template>

<script>
import { xdWalletTxFlowApi, walletStatisticsApi, partnerPayExport } from '@/api/partners'
import { downloadFile } from '@/utils/download'

export default {
  props: {
    code: {
      type: String,
      default: ''
    },
    level: {
      type: String,
      default: ''
    }
  },
  watch: {
    code: {
      handler(val) {
        if (val) {
          this.defaultParams.refUser = val
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      api: xdWalletTxFlowApi,
      activeName: '0',
      exportQuery: {},
      defaultParams: {
        type: ''
      },
      isExporting: false,
      typeStatus: {
        1: '充值',
        2: '充电',
        3: '充电赠送',
        4: '充电分成',
        5: '合伙人贡献收益',
        6: '商家分成',
        7: '月卡分成',
        10: '充电退款 ',
        11: '充值退款',
        20: '发起提现',
        21: '提现',
        22: '提现退回',
        8: '充值分成',
        28: '超时占用分成',
        29: '超时占用退款',
      },
      searchColumns: [
        {
          label: '类型',
          prop: 'type',
          type: 'select',
          option: [
            {
              label: '充电分成',
              value: 4
            },
            {
              label: '合伙人贡献收益',
              value: 5
            },
            {
              label: '提现',
              value: 21
            },
            {
              label: '充值分成',
              value: 8
            },
            {
              label: '用户提现退款',
              value: 11
            },
            {
              label: '超时占用分成',
              value: 28
            },
            {
              label: '超时占用退款',
              value: 29
            }
          ]
        },
        {
          label: '时间范围',
          prop: 'date',
          type: 'date'
        }
      ],
      columns: [
        {
          label: '日期',
          prop: 'createTime',
          type: 'slot',
          slotName: 'createdTime'
        },
        {
          label: '订单编号',
          prop: 'remarks'
        },
        {
          label: '钱包明细',
          prop: 'storeName'
        },
        {
          label: '流水号',
          prop: 'transactionId'
        },
        {
          label: '类型',
          prop: 'type',
          type: 'slot',
          slotName: 'status'
        },
        {
          label: '金额',
          prop: 'sum',
          type: 'slot',
          slotName: 'sum'
        },
        {
          label: '账户余额',
          prop: 'afterWalletSum'
        }
      ],
      statisticsData: {} //钱包统计数据
    }
  },

  created() {
    this.getStatistics()
  },

  methods: {
    handleSearch(val) {
      this.$refs.table.search(val)
      this.exportQuery = { ...val }
    },
    handleClick() {
      if (this.activeName === '0') this.defaultParams.type = ''
      if (this.activeName === '1') this.defaultParams.type = 4
      if (this.activeName === '2') this.defaultParams.type = 5
      if (this.activeName === '3') this.defaultParams.type = 21
      this.$refs.table.init()
    },
    getStatistics() {
      walletStatisticsApi(this.code).then(res => {
        this.statisticsData = res.data
        console.log('统计数据:>> ', res)
      })
    },
    handleExport() {
      if (!this.code) {
        this.$message.error('合伙人编码不能为空')
        return
      }

      if (this.isExporting) {
        this.$message.warning('正在导出中，请勿重复点击')
        return
      }

      this.isExporting = true
      this.$message.info('请稍等,正在导出...')

      const params = {
        refUser: this.code,
        ...this.exportQuery
      }
      partnerPayExport(params)
        .then((blob) => {
          downloadFile(blob, `合伙人钱包_${new Date().getTime()}.xlsx`)
          this.$message.success('导出成功')
        })
        .catch((error) => {
          console.error('导出失败:', error)
        })
        .finally(() => {
          this.isExporting = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.statistics {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
  padding: 10px 30px;
  background: #f3f7fa;
  .statistics-item {
    width: 25%;
    font-size: 14px;
    padding: 10px 0;
    .statistics-item-value {
      margin-top: 10px;
    }
  }
}
</style>
